import Vue from "vue";
import router from "./router";
import * as VueGoogleMaps from 'vue2-google-maps';
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "material-design-icons-iconfont/dist/material-design-icons.css";

//import './traceroute-hub';

Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAob1zHMAb4EsUhoOj6Cum2gMEmvPerIHs',
    //libraries: 'places',
  }
});

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");
